import React from "react";

const TextCard = ({ header, children }) => {
    return (
        <div className="bootstrap-styles">
            <div className="olympus-styles">
                <div className="card">
                    <div className="card-header">
                        <h3 className="mb-0 pt-2 pb-2">{header}</h3>
                    </div>
                    <div className="pl-5 pr-5 pt-2">{children}</div>
                </div>
            </div>
        </div>
    );
};

export default TextCard;
